exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".echarts-container[data-v-54faff9a] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
